export default "__VITE_ASSET__CXjRFbdY__";